module.exports = __webpack_public_path__ + "img/volles_Glas.7af34096.svg";